import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UsersService } from '../../../shared/services/users.service';
import { DataContextService } from '../../../shared/services/data-context.service';
import { ConstantsService } from '../../../shared/services/Constants/constants.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.less']
})
export class UserModalComponent implements OnInit, OnDestroy {
  userModalDetails: any;
  cityNamesDisplay: string;
  officeNamesDisplay: string;
  practiceNamesDisplay: string;
  private service_URL: any;
  private unsubscribe$ = new Subject<void>();

  constructor(public modalRef: BsModalRef, private userService: UsersService, private _dataContextService: DataContextService) {
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
     // Display cities and offices from initial data
     this.cityNamesDisplay = this.userModalDetails.cityNames
      ? this.userModalDetails.cityNames.split(',').map(c => c.trim()).join(', ')
      : this.userModalDetails.cityName || '';
    this.officeNamesDisplay = this.userModalDetails.officeNames
      ? this.userModalDetails.officeNames.split(',').map(o => o.trim()).join(', ')
      : this.userModalDetails.officeName || '';
    
    // Fetch master list and user details
    this._dataContextService.get<any>(this.service_URL.Users.getMasterData)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((masterList) => {
      const practiceMasterData = masterList.practiceList || [];
      
      // Fetch full user details to get all practices
      this.userService.getUsersDataById(this.userModalDetails.appUserID)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        const userPractices = data.userPractice || data.userPractices || [];
        
        if (userPractices && userPractices.length > 0) {
          // Get practice names for all user practices
          const practiceNames = userPractices.map(up => {
            const practiceId = up.practiceID || up.practiceId;
            const practice = practiceMasterData.find(p => p.practiceId === practiceId);
            return practice ? practice.name : null;
          }).filter(name => name !== null);
          
          this.practiceNamesDisplay = practiceNames.length > 0 ? practiceNames.join(', ') : 'Not Applicable';
        } else if (data.userData && data.userData.practiceID > 0) {
          // Fallback to single practice from userData.practiceID when userPractice is empty
          const practice = practiceMasterData.find(p => p.practiceId === data.userData.practiceID);
          this.practiceNamesDisplay = practice ? practice.name : 'Not Applicable';
        } else {
          this.practiceNamesDisplay = 'Not Applicable';
        }
      });
    });
  }
  
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
